<template lang="pug">
  .base-input-confirm-change
    .input-view(v-if="onEdit")
      b-form-input(v-model="editValue" v-bind="$attrs")
      font-awesome-icon.icon-btn(
        @click="onSave"
        :icon="['fas', 'check']"
        style="color: var(--primary)"
      )
      font-awesome-icon.icon-btn(
        @click="onCancel"
        :icon="['fas', 'times']"
        style="color: var(--danger)"
      )
    .value-view(v-else)
      span {{fomattedValue}}
      font-awesome-icon.icon-btn(v-if="!disabled" @click="onEdit=true" :icon="['far', 'edit']" size="lg")
</template>

<script>
export default {
  props: ['value', 'disabled'],
  data () {
    return {
      onEdit: false,
      editValue: null
    }
  },
  computed: {
    fomattedValue () {
      if (this.$attrs) {
        if (this.$attrs.type === 'date') {
          return this.$options.filters.dateFormat(new Date(this.editValue), 'DD-MM-YYYY')
        }
      }
      return this.editValue
    }
  },
  watch: {
    value () {
      this.editValue = this.value
    }
  },
  methods: {
    onSave () {
      this.onEdit = false
      this.$emit('input', this.editValue)
      this.$emit('change', this.editValue)
    },
    onCancel () {
      this.onEdit = false
      this.editValue = this.value
    }
  },
  created () {
    this.editValue = this.value
    console.log(this.$attrs.type)
    console.log()
  }
}
</script>

<style lang="scss" scoped>
.base-input-confirm-change {
  .input-view {
    font-size: 18px;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
  .value-view {
    display: inline-flex;
    align-items: center;
    gap: 12px;
  }
}
</style>
